import { Lock, Unlock } from 'lucide-react';
import React from 'react';
import { IconButton, FormDrawer } from '../../ui';
import FormBlockDeblockEntite from '../Forms/FormBlockDeblockEntite';

export default function BlockDeblockEntite(props: { handleFunction: any, entite: any }) {
    const [open, setOpen] = React.useState(false);
    const isActive = props.entite.Statut == 1;

    return (
        <div>
            <IconButton onClick={() => setOpen(true)} color={isActive ? 'success' : "danger"} size={32} tooltip={isActive ? 'Bloquer' : "Débloquer"}>
                {isActive ? <Unlock size={16} /> : <Lock size={16} />}
            </IconButton>
            <FormDrawer
                open={open}
                onClose={() => setOpen(false)}
                title={`${isActive ? 'Blocage' : "Déblocage"} de l'entité`}
                hint={isActive
                    ? "Attention : le blocage rendra cette entité inaccessible pour tous ses utilisateurs."
                    : "Le déblocage réactivera l'accès de cette entité."}
            >
                <FormBlockDeblockEntite handleFunction={() => { setOpen(false); props.handleFunction() }} entite={props.entite} />
            </FormDrawer>
        </div>
    );
}
